<template>
    <div class="wrap">
        <div class="hint" @click="hintDialog">
            使用提示
        </div>
        <div class="cnt">
            <p class="goApply"><span @click="$router.push({path:'/time/ApplyTime'})"><van-icon class="arrow" name="arrow-left" />继续申请</span></p>
            <h3>
                <img src="@/assets/img/success.png" alt="">
                <p>申请成功</p>
            </h3>
            <h4>您的权属证明和数字资产凭证</h4>
            <div class="certificate">
                <img :src="opusInfo.pdfThumbnailUrl" alt="" @click="imgPreview(opusInfo.pdfThumbnailUrl)">
                <img :src="opusInfo.enPdfThumbnailUrl" alt="" @click="imgPreview(opusInfo.enPdfThumbnailUrl)">
            </div>
            <div class="download">
                <span class="down" @click="downPackage('tsa')">下载可信时间戳<sup>®</sup>证书</span>
                <span class="look" @click="lookDetail">查看认证详情</span>
            </div>
        </div>
        <!-- <div class="advertising">
            <img src="@/assets/img/advertising.png" alt="">
        </div> -->
        <van-dialog v-model="show" title="使用提示" confirm-button-color="#4C72F9" closeOnClickOverlay>
            <div class="hint_cnt">
                <p>1、数据/文件在申请时间戳后除文件名外不能有任何形式的修改和变化，否则无法通过可信时间戳<sup>®</sup>验证。 如需查看或修改需将原始文件备份并在复制件上进行。 </p>
                <p>2、可信时间戳<sup>®</sup>证书是由联合信任时间戳服务中心签发的具有法律效力的电子凭证，用于证明电子数据/文件自申请时间戳时起，内容保持完整、未被更改。 </p>
                <p>3、可信时间戳<sup>®</sup>证书包括可信时间戳<sup>®</sup>(*.tsa)和可信时间戳<sup>®</sup>认证证书(*.pdf),可根据需要单独或合并使用。其中可信时间戳<sup>®</sup>(*.tsa)是用于验证的token，是一个不能打开查看的加密文件；可信时间戳<sup>®</sup>认证证书(*.pdf)是一个可以查看的证书，记载了数据/文件申请认证时的相关信息。</p>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { ImagePreview } from 'vant';
import qs from 'qs'
import { findOpusInfo, downloadFile } from '@/api/service'
import { filterParams } from '@/utils/filter'
import { mapState } from "vuex";
export default {
    data() {
        return {
            show:false,
            serialNos: [],
            userinfo: {},
            opusInfo: {},
        };
    },

    components: {},

    computed: {
        ...mapState({
            parentIframe: (state) => state.app.parentIframe,
        }),
    },

    created() {
        this.serialNos = JSON.parse(sessionStorage.getItem('serialNos'))
        this.userinfo = this.$store.state.userInfo
        this.getInfo(JSON.parse(sessionStorage.getItem('serialNos')))
    },

    mounted() {},

    methods: {
        imgPreview(path){
            ImagePreview({
                images: [path],
                showIndex: false
            });
        },
        hintDialog(){
            this.show=true;
        },
        lookDetail() {
            let obj = {
                serialNo: this.serialNos[0],
            }
            this.$setlocalStorage("listObj",{
                searchParam:null,
                serialNos:this.serialNos
            });
            this.$router.push({
                path: '/file/FileDetail',
                query: filterParams(obj),
            })
        },
        async getInfo(data) {
            if (data.length > 1) {
                this.opusInfo = []
                let res = await findOpusInfo(data[0])
                this.opusInfo = res
            } else if (data.length === 1) {
                let res = await findOpusInfo(data)
                this.opusInfo = res
            }
            console.log(this.opusInfo)
        },
        async downPackage(str) {
            let {parentIframe}=this;
            if(parentIframe === 'ANDROID-RIGHTS' || parentIframe === 'IOS-RIGHTS' || parentIframe === 'HARMONYOSNEXT-RIGHTS' || parentIframe ==='WEIXIN'){
                this.$TsaAlertV2.show({
                    title: '下载证据',
                    message: '请登录电脑端证据管理中心“https://file.tsa.cn/”在[全部证据]中操作。',
                    type: 'warn',
                    confirmButtonText: '我知道了',
                    onConfirm: () => {
                        this.$TsaAlertV2.hide()
                    },
                })
                return
            }

            let obj = {
                serialNos: this.serialNos,
            }
            var baseURL
            if (process.env.NODE_ENV === 'development') {
                baseURL = '/api/api'
            } else {
                baseURL = '/opus/api'
            }
            window.open(
                baseURL +
                `/opus/downloadMultiFile?${qs.stringify(obj, { indices: false })}`
            )
        },
    },
};
</script>
<style src="../../assets/css/applyResult.less" scoped lang="less"></style>
